import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the type for the initial state
interface MatchSelectionFilterState {
    teams: any[];
    
}

// Define the initial state
const initialState: MatchSelectionFilterState = {
    teams: [],
};

// Create the slice
export const matchSelectionFilterSlice = createSlice({
    name: 'matchSelectionFilter',
    initialState,
    reducers: {
        setTeams: (state, action: PayloadAction<any[]>) => {
            state.teams = action.payload;
        }
    }
});

// Export action creators
export const { setTeams } = matchSelectionFilterSlice.actions;

// Export the reducer
export default matchSelectionFilterSlice.reducer;